export default function Footer(){

  return (

    <footer className="footer">

      <p>© 2026 Swadesi Foods</p>

    </footer>

  );

}